<template>
  <div class="financeManage-coinManage-page">
    <p class="hasBottomLine">借贷宝币种管理</p>
    <div class="add-btn">
      <el-button type="primary" @click="editBtn({}, 'add')">新增</el-button>
    </div>
    <div class="table-box">
      <el-table :data="coinConfListInfo" border style="width: 99.9%">
        <el-table-column prop="id" label="id" width="40"> </el-table-column>
        <el-table-column prop="coinType" label="币种" width="80">
        </el-table-column>
        <el-table-column prop="canMortgage" label="是否支持抵押" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.canMortgage == true">√</span>
            <span v-else style="color: red">×</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="mortgageRate"
          label="抵押质押率（%）"
          width="140"
        >
        </el-table-column>

        <el-table-column
          prop="floatRate"
          label="质押率浮动范围（%）"
          width="160"
        >
        </el-table-column>

        <el-table-column prop="canBorrow" label="是否支持借贷" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.canBorrow == true">√</span>
            <span v-else style="color: red">×</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="单笔借贷范围" width="140">
          <template slot-scope="scope">
            {{ scope.row.minBorrow }} - {{ scope.row.maxBorrow }}
          </template>
        </el-table-column>
        <el-table-column prop="userMaxBorrow" label="单用户最大借币数量" width="140"></el-table-column>
        <el-table-column prop="coinMaxBorrow" label="单币种最大借币数量" width="140"></el-table-column>
        <el-table-column prop="maxDay" label="最长借贷周期（天）" width="160">
        </el-table-column>

        <el-table-column prop="dayRate" label="按日计息（日利率）" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.supportDayRate">
              <p
                v-for="(item, index) in scope.row.dayRate"
                :key="'day' + index"
              >
                <span v-if="index + 1 < scope.row.dayRate.length">
                  {{ scope.row.dayRate[index].limit }} ~
                  {{ scope.row.dayRate[index + 1].limit }} -- ({{
                    scope.row.dayRate[index].rate
                  }}‱)
                </span>
                <span v-else-if="index + 1 == scope.row.dayRate.length">
                  {{ scope.row.dayRate[index].limit }} ~ ∞ ({{
                    scope.row.dayRate[index].rate
                  }}‱)
                </span>
              </p>
            </div>
            <div v-else>已禁用</div>
          </template>
        </el-table-column>
        <el-table-column prop="hourRate" label="按时计息（时利率）" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.supportHourRate">
              <p
                v-for="(item, index) in scope.row.hourRate"
                :key="'day' + index"
              >
                <span v-if="index + 1 < scope.row.hourRate.length">
                  {{ scope.row.hourRate[index].limit }} ~
                  {{ scope.row.hourRate[index + 1].limit }} ({{
                    scope.row.hourRate[index].rate
                  }}‱)
                </span>
                <span v-else-if="index + 1 == scope.row.hourRate.length">
                  {{ scope.row.hourRate[index].limit }} ~ ∞ ({{
                    scope.row.hourRate[index].rate
                  }}‱)
                </span>
              </p>
            </div>
            <div v-else>已禁用</div>
          </template>
        </el-table-column>

        <el-table-column prop="sort" label="优先级"> </el-table-column>
        <el-table-column prop="scale" label="支持小数位数" width="110">
        </el-table-column>
        <el-table-column prop="maxDay" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="primary" @click="editBtn(scope.row, 'edit')"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="footer-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="coinConfListTotal"
      >
      </el-pagination>
    </div>

    <!---dialog--->

    <el-dialog
      :title="editType == 'edit' ? editInfo.coinType + '编辑' : '新增'"
      class="bk-ui5-dialog"
      :visible.sync="editDialog"
    >
      <p class="titleStrong">借贷宝币种：</p>
      <div class="itemOne">
        <div class="setInputBox">
          <el-input placeholder="请输入借贷宝币种" v-model="editInfo.coinType">
          </el-input>
        </div>
      </div>
      <p class="titleStrong">借贷宝币种计算支持小数位数：</p>
      <div class="itemOne">
        <p class="descText">
          <span>小数位数：</span>
          <span>0 ≤ X ≤ 8，正整数</span>
        </p>
        <div class="setInputBox">
          <el-input
            placeholder="请输入支持小数位数"
            v-model="editInfo.scale"
            type="number"
          >
          </el-input>
        </div>
      </div>

      <div class="itemOne">
        <p class="descText">
          <span>优先级（用于前端借贷主页币种排列先后）：</span>
          <span>0~10000正整数</span>
        </p>
        <div class="setInputBox">
          <el-input
            placeholder="请输入币种优先级"
            v-model="editInfo.sort"
            type="number"
          >
          </el-input>
        </div>
      </div>

      <p class="titleStrong">关于抵押:</p>
      <div class="itemOne">
        <p class="descText">
          <span>是否支持抵押：</span>
          <span
            ><el-switch
              v-model="editInfo.canMortgage"
              active-text="支持"
              inactive-text="不支持"
            ></el-switch
          ></span
          >
        </p>
        <p class="descText">
          <span>抵押质押率（%）：</span>
          <span>0﹤X ≤100,支持两位小数 </span>
        </p>
        <div class="setInputBox">
          <el-input
            placeholder="请输入币种优先级"
            v-model="editInfo.mortgageRate"
          >
          </el-input>
        </div>
      </div>
      <div class="itemOne">
        <p class="descText">
          <span>浮动范围（%）：</span>
          <span>0﹤X ≤100,支持两位小数</span>
        </p>
        <div class="setInputBox">
          <el-input placeholder="请输入浮动范围" v-model="editInfo.floatRate">
          </el-input>
        </div>
      </div>

      <p class="titleStrong">关于借贷:</p>

      <div class="itemOne">
        <p class="descText">
          <span>是否支持借贷：</span>
          <span
            ><el-switch
              v-model="editInfo.canBorrow"
              active-text="支持"
              inactive-text="不支持"
            ></el-switch
          ></span>
        </p>
        <p class="descText">
          <span>单笔借贷范围：</span>
          <span> 0﹤交易范围≤9999999，支持8位小数</span>
        </p>
        <div class="setInputBox2">
          <el-input placeholder="请输入最低限额" v-model="editInfo.minBorrow">
            <template slot="append">{{ editInfo.coinType }}</template>
          </el-input>
          <span>一</span>
          <el-input placeholder="请输入最高限额" v-model="editInfo.maxBorrow">
            <template slot="append">{{ editInfo.coinType }}</template>
          </el-input>
        </div>
        <p class="descText">
          <span>单用户最大可借币数量：</span>
        </p>
        <div>
          <el-input placeholder="请输入单用户最大可借币数量" v-model="editInfo.userMaxBorrow">
            <template slot="append">{{ editInfo.coinType }}</template>
          </el-input>
        </div>
        <p class="descText">
          <span>单币种最大可借币数量：</span>
        </p>
        <div>
          <el-input placeholder="请输入单币种最大可借币数量" v-model="editInfo.coinMaxBorrow">
            <template slot="append">{{ editInfo.coinType }}</template>
          </el-input>
        </div>
      </div>

      <div class="itemOne">
        <p class="descText">
          <span>最长借贷周期（天）：</span>
          <span> 0﹤交易范围≤9999，正整数</span>
        </p>
        <div class="setInputBox">
          <el-input placeholder="请输入最长借贷周期" v-model="editInfo.maxDay">
          </el-input>
        </div>
      </div>

      <p class="titleStrong">计息方式及阶梯利率：</p>

      <div class="itemOne">
        <p class="descText">
          <span>按日计息</span>
          <span
            ><el-switch
              v-model="editInfo.supportDayRate"
              active-text="支持"
              inactive-text="不支持"
            ></el-switch
          ></span>
        </p>
        <p class="descText">
          <span>请设置数量范围（{{editInfo.coinType}}）：</span>
          <span> 日利率（‱）</span>
        </p>
        <p class="descText">
          <span>0﹤配置范围≤9999999</span>
          <span> 0﹤X≤100，支持4小数</span>
        </p>
        <div class="setRange" v-if="editInfo.supportDayRate">
          <div
            class="rangeItem"
            v-for="(dayItem, index) in editInfo.dayRate"
            :key="'day' + index"
          >
            <div class="rangeItemBox">
              <el-input placeholder="请输入范围数量" v-model="dayItem.limit">
              </el-input>
            </div>
            <div class="rateBox">
              <div class="rateLeft">-----------------------</div>
              <div class="rateRight">
                <el-input placeholder="请输入借贷日利率" v-model="dayItem.rate">
                  <template slot="append"> ‱ </template>
                </el-input>
              </div>
            </div>
          </div>
          <div class="rangeItemBox">
            <el-input
              placeholder="请输入范围数量"
              disabled=""
              v-model="infinityText"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="itemOne">
        <p class="descText">
          <span>按时计息</span>
          <span
            ><el-switch
              v-model="editInfo.supportHourRate"
              active-text="支持"
              inactive-text="不支持"
            ></el-switch
          ></span>
        </p>
        <div class="setRange" v-if="editInfo.supportHourRate">
          <div
            class="rangeItem"
            v-for="(hourItem, index) in editInfo.hourRate"
            :key="'hour' + index"
          >
            <div class="rangeItemBox">
              <el-input placeholder="请输入范围数量" v-model="hourItem.limit">
              </el-input>
            </div>
            <div class="rateBox">
              <div class="rateLeft">-----------------------</div>
              <div class="rateRight">
                <el-input
                  placeholder="请输入借贷日利率"
                  v-model="hourItem.rate"
                >
                  <template slot="append"> ‱ </template>
                </el-input>
              </div>
            </div>
          </div>
          <div class="rangeItemBox">
            <el-input
              placeholder="请输入范围数量"
              disabled=""
              v-model="infinityText"
            >
            </el-input>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editCommitBtn()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "coinManage",
  data() {
    return {
      editType: "",
      editDialog: false,
      value: "",
      editInfo: {},
      infinityText: "+∞",
      rateDayRangeArr: [
        { limit: "", rate: "" },
        { limit: "", rate: "" },
        { limit: "", rate: "" },
        { limit: "", rate: "" },
        { limit: "", rate: "" },
      ],
      rateHourRangeArr: [
        { limit: "", rate: "" },
        { limit: "", rate: "" },
        { limit: "", rate: "" },
        { limit: "", rate: "" },
        { limit: "", rate: "" },
      ],

      currentPage: 1,
      pageSize: 5,
    };
  },
  computed: {
    ...mapState("FinanceManage", ["coinConfListInfo", "coinConfListTotal"]),
  },
  methods: {
    ...mapActions("FinanceManage", ["getCoinConfList"]),

    sizeChange(val) {
    },
    pageChange(val) {
      this.getPageListInfo();
    },

    getPageListInfo() {
      let postData = {
        page: this.currentPage,
        size: this.pageSize,
      };

      this.getCoinConfList(postData);
    },

    handleSearch() {},
    showDialog(n) {
      this.dialogArr[n] = true;
    },
    handleOpenSwitch(openStatus) {
      this.dialogArr.openSwitchDialog = true;
      return false;
    },
    clearForm() {
      this.editDialog = false;
    },

    operationBtn() {
      let that = this;
      api.mortgageOperation(that.operationForm).then((res) => {
        if (!res.code) {
          that.clearForm();
          that.getMortgageConfig();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    },

    editBtn(row, type) {
      this.editType = type;
      if (type == "edit") {
        this.editInfo = JSON.parse(JSON.stringify(row));
      } else {
        this.editInfo = {
          coinType: "",
          scale: "",
          sort: "",
          mortgageRate: "",
          floatRate: "",
          minBorrow: "",
          maxBorrow: "",
          userMaxBorrow: "",
          coinMaxBorrow: "",
          maxDay: "",
          canBorrow: false,
          supportDayRate: false,
          canMortgage: false,
          supportHourRate: false,
          dayRate: [],
          hourRate: []
        };
      }
      this.editInfo.dayRate = this.editInfo.dayRate ? this.editInfo.dayRate : [];
      this.editInfo.hourRate = this.editInfo.hourRate ? this.editInfo.hourRate : [];
      let dayRateNeedLen = this.editInfo.dayRate.length ? 5 - this.editInfo.dayRate.length : 5;
      for(var i = 0; i < dayRateNeedLen; i++) {
        this.editInfo.dayRate.push({
          limit: '',
          rate: ''
        });
      }
      let hourRateNeedLen = this.editInfo.hourRate.length ? 5 - this.editInfo.hourRate.length : 5;
      for(var j = 0; j < hourRateNeedLen; j++) {
        this.editInfo.hourRate.push({
          limit: '',
          rate: ''
        });
      }
      this.editDialog = true;
    },
    clearEmptyRate(rateArr) {
      let re = [];
      rateArr.forEach((v, i, a) => {
        if(v.limit !== '' && v.rate !== '') re.push(v);
      });
      return re;
    },

    editCommitBtn() {
      let that = this;
      let postData = JSON.parse(JSON.stringify(this.editInfo));
      postData.dayRate = JSON.stringify(this.clearEmptyRate(postData.dayRate));
      postData.hourRate = JSON.stringify(this.clearEmptyRate(postData.hourRate));
      api.editCoinConfig(postData).then((res) => {
        if (!res.code) {
          that.clearForm();
          that.getPageListInfo();
          that.$message.success(res.msg);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getPageListInfo();
  },
};
</script>

<style lang="less">
.financeManage-coinManage-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
      }
    }
  }
  .footer-box {
    padding: 20px 20px 50px 0px;
  }

  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-ui5-dialog {
    .el-dialog {
      width: 40%;
      .el-dialog__header {
        text-align: center;
        color: red;
      }
      .el-dialog__body {
        .titleStrong {
          font-size: 18px;
          font-weight: bold;
        }
        .itemOne {
          padding-bottom: 30px;

          .descText {
            display: flex;
            justify-content: space-between;
            text-align: center;
            .el-switch {
              margin-right: 15px;
            }
          }
          .setInputBox {
          }
          .setInputBox2 {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .setRange {
            width: 100%;
            overflow: hidden;
            .rangeItem {
              width: 100%;
              .rangeItemBox {
                width: 50%;
              }
              .rateBox {
                width: 60%;
                float: right;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 0;
                .rateLeft {
                  height: 30px;
                  line-height: 30px;
                  border-left: 1px solid #cccccc;
                  padding-left: 12px;
                }
              }
            }
          }
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
  .add-btn {
    margin-bottom: 18px;
  }
}
</style>
